export default "__VITE_ASSET__CSU0rN23__"